import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white customer-satisfaction-box" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-sm-25 p-lg-30 letter-spacing" }
const _hoisted_3 = {
  key: 0,
  id: "customerSatisfactionChart2",
  class: "chart"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "mb-15 mb-md-25 d-flex align-items-center justify-content-between" }, [
        _createElementVNode("h6", { class: "card-title fw-bold mb-0" }, "Přehled událostí v čase")
      ], -1)),
      (_ctx.preparedData.inputValues != undefined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_apexchart, {
              type: "bar",
              height: "350",
              options: _ctx.preparedData.chartOptions,
              series: _ctx.preparedData.inputValues
            }, null, 8, ["options", "series"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}